import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jira-icon-full-width",
  "use": "icon-jira-icon-full-width-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jira-icon-full-width\">\n    <path d=\"M11.8527 5.675L6.5157 0.50727L5.9918 0L1.9809 3.88375L0.147337 5.675C-0.0491125 5.8653 -0.0491125 6.1664 0.147337 6.3408L3.81446 9.8917L5.9918 12L10.0027 8.1162L10.0682 8.0528L11.8527 6.3408C12.0491 6.1506 12.0491 5.8494 11.8527 5.675ZM5.9918 7.7834L4.1583 6.0079L5.9918 4.2325L7.8254 6.0079L5.9918 7.7834Z\" fill=\"#2684FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol